import React, { useContext, useEffect,useState } from 'react'
import { Selectbox } from './Shared'
import axios from 'axios'
import UserContext from '../Context/UserContext'
import Select from './Select'


/* AREAS 
'Digital'}
'Paper Areas'}
'Web Rolls'}
'Colormax'}
'Floor'}

*/

export const PLSSalesReps = async() => {
    
 try {
    const response = await axios.get('https://highgroundapi.herokuapp.com/employee/sales');

    return response.data;
  } catch (err) {
    console.log(err);
    throw err; // or return null/empty array depending on your needs
  }

}



export const PLSCSRReps = async() => {
    
 try {
    const response = await axios.get('https://highgroundapi.herokuapp.com/employee/csr');
  
    return response.data;
  } catch (err) {
    console.log(err);
    throw err; // or return null/empty array depending on your needs
  }

}


export const SalesReps = ({onChange,value}) => {
const userInfo = useContext(UserContext)
  const [list, setList]= useState([])

  useEffect(() => {
      const getReps = async() => {
  await axios.get('https://highgroundapi.herokuapp.com/employee/sales')
  .then(res => {
  
    setList(res.data)
      })
  .catch(err => console.log(err))
      }
      getReps()
  },[])

    return (
      <Selectbox onChange={onChange} value={value}  style={{fontWeight:"bold",padding:"6px 4px",borderLeft:"20px solid rgba(122, 187, 67, .5)"}} border="1px solid rgba(122, 187, 67, .5)"   required >
      <option value="" selected disabled>Select Sales Rep</option>
      {
      list.map(item => {
        return  <option value={item._id} selected={item._id === userInfo.userInfo.salesrep ? "selected" : ""}>{item?.firstName} {item?.lastName}</option>
      })
  }
</Selectbox>
  )
}


export const CSRReps = ({onChange,value}) => {
const userInfo = useContext(UserContext)
    const [list, setList]= useState([])
    
    useEffect(() => {
        const getReps = async() => {
    await axios.get('https://highgroundapi.herokuapp.com/employee/csr')
    .then(res => setList(res.data))
    .catch(err => console.log(err))
        }
        getReps()
    },[])
      return (
        <Selectbox onChange={onChange} value={value}  style={{fontWeight:"bold",padding:"6px 4px",borderLeft:"20px solid rgba(122, 187, 67, .5)"}} border="1px solid rgba(122, 187, 67, .5)"   required >
            <option value="" selected disabled>Select CSR Rep</option>
            {
            list.map(item => {
              return  <option value={item._id} selected={item._id === userInfo.userInfo.csr ? "selected" : ""}>{item?.firstName} {item?.lastName}</option>
            })
        }
    </Selectbox>
      )
    }



//     export const SalesRepsByEmpid = ({onChange,value,disabled}) => {
// console.log(value)
//       const [list, setList]= useState([])
        
//       useEffect(() => {
//           const getReps = async() => {
//       await axios.get('https://highgroundapi.herokuapp.com/employee/sales')

//       .then(res => {console.log(res.data);setList(res.data)})
//       .catch(err => console.log(err))
//           }
//           getReps()
//       },[])
//         return (
//           <Selectbox onChange={onChange} value={value}  style={{fontWeight:"bold",padding:"6px 4px",borderLeft:"20px solid rgba(122, 187, 67, .5)"}} border="1px solid rgba(122, 187, 67, .5)" disabled={disabled}  required >
//               <option value="" selected disabled>Select Sales Rep</option>
//               {
//               list.map(item => {
//                 return  <option value={item.empId}>{item.preferredName > "" ?item.preferredName : item.firstName} {item.lastName}</option>
//               })
//           }
//       </Selectbox>
//       )
//     }



export const SalesRepsByEmpid = ({ onChange, value, disabled }) => {
  const [list, setList] = useState([]);
  const [isValidValue, setIsValidValue] = useState(true);

  useEffect(() => {
    const getReps = async () => {
      try {
        const res = await axios.get('https://highgroundapi.herokuapp.com/employee/sales');
     
        setList(res.data);

        // After list is loaded → check if current value still exists
        if (value && value !== "") {
          const exists = res.data.some(rep => rep.empId === value);
          if (!exists) {
            console.warn(`Sales rep with empId ${value} no longer exists → clearing value`);
            setIsValidValue(false);
            // Notify parent to clear the value
            onChange?.({ target: { value: "" } });
          } else {
            setIsValidValue(true);
          }
        }
      } catch (err) {
        console.error('Failed to load sales reps:', err);
      }
    };

    getReps();
  }, []); // Only run once on mount

  // Optional: re-validate when external value changes
  useEffect(() => {
    if (list.length > 0 && value && value !== "") {
      const exists = list.some(rep => rep.empId === value);
      if (!exists && isValidValue) {
        console.warn(`Value ${value} became invalid after list update`);
        onChange?.({ target: { value: "" } });
        setIsValidValue(false);
      }
    }
  }, [value, list, onChange, isValidValue]);

  return (
    <Selectbox
      onChange={onChange}
      value={isValidValue ? value : ""}   // Force empty if invalid
      style={{
        fontWeight: "bold",
        padding: "6px 4px",
        borderLeft: "20px solid rgba(122, 187, 67, .5)"
      }}
      border="1px solid rgba(122, 187, 67, .5)"
      disabled={disabled}
      required
    >
      <option value="" disabled>
        Select Sales Rep
      </option>
      {list.map((item) => (
        <option key={item.empId} value={item.empId}>
          {item.preferredName && item.preferredName.trim() !== ""
            ? item.preferredName
            : item.firstName}{" "}
          {item.lastName}
        </option>
      ))}
    </Selectbox>
  );
};

export const CSRRepsByEmpid = ({ onChange, value, disabled }) => {
  const [list, setList] = useState([]);
  const [isValidValue, setIsValidValue] = useState(true);

  useEffect(() => {
    const getReps = async () => {
      try {
        const res = await axios.get('https://highgroundapi.herokuapp.com/employee/csr');
    
        setList(res.data);

        // After list is loaded → check if current value still exists
        if (value && value !== "") {
          const exists = res.data.some(rep => rep.empId === value);
          if (!exists) {
            console.warn(`Sales rep with empId ${value} no longer exists → clearing value`);
            setIsValidValue(false);
            // Notify parent to clear the value
            onChange?.({ target: { value: "" } });
          } else {
            setIsValidValue(true);
          }
        }
      } catch (err) {
        console.error('Failed to load sales reps:', err);
      }
    };

    getReps();
  }, []); // Only run once on mount

  // Optional: re-validate when external value changes
  useEffect(() => {
    if (list.length > 0 && value && value !== "") {
      const exists = list.some(rep => rep.empId === value);
      if (!exists && isValidValue) {
        console.warn(`Value ${value} became invalid after list update`);
        onChange?.({ target: { value: "" } });
        setIsValidValue(false);
      }
    }
  }, [value, list, onChange, isValidValue]);

  return (
    <Selectbox
      onChange={onChange}
      value={isValidValue ? value : ""}   // Force empty if invalid
      style={{
        fontWeight: "bold",
        padding: "6px 4px",
        borderLeft: "20px solid rgba(122, 187, 67, .5)"
      }}
      border="1px solid rgba(122, 187, 67, .5)"
      disabled={disabled}
      required
    >
      <option value="" disabled>
        Select Sales Rep
      </option>
      {list.map((item) => (
        <option key={item.empId} value={item.empId}>
          {item.preferredName && item.preferredName.trim() !== ""
            ? item.preferredName
            : item.firstName}{" "}
          {item.lastName}
        </option>
      ))}
    </Selectbox>
  );
};

    // export const CSRRepsByEmpid = ({onChange,value,disabled}) => {

    //   const [list, setList]= useState([])
        
    //   useEffect(() => {
    //       const getReps = async() => {
    //   await axios.get('https://highgroundapi.herokuapp.com/employee/csr')
    //   .then(res => setList(res.data))
    //   .catch(err => console.log(err))
    //       }
    //       getReps()
    //   },[])
    //     return (
    //       <Selectbox onChange={onChange} value={value}  style={{fontWeight:"bold",padding:"6px 4px",borderLeft:"20px solid rgba(122, 187, 67, .5)"}} border="1px solid rgba(122, 187, 67, .5)" disabled={disabled}  required >
    //           <option value="" selected disabled>Select Sales Rep</option>
    //           {
    //           list.map(item => {
    //             return  <option value={item.empId}>{item.preferredName > "" ?item.preferredName : item.firstName} {item.lastName}</option>
    //           })
    //       }
    //   </Selectbox>
    //   )
    // }


